module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/landing/startup-cc1fa211c8b67b2dc0111862cfa55307.jpg";